import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type {
    GetPlatformCostsOverviewResponse,
    UseGetPlatformCostsOverviewParams,
    UseGetPlatformCostsOverviewResult,
} from './types';

const useGetPlatformCostsOverview = ({
    period,
}: UseGetPlatformCostsOverviewParams): UseGetPlatformCostsOverviewResult => {
    const searchParams = new URLSearchParams({
        startDate: period.startDate,
        endDate: period.endDate,
    });
    const pathname = `/admin/platform-costs?${searchParams.toString()}`;

    const { data, isLoading, error, refetch } = useHttpQuery<GetPlatformCostsOverviewResponse>({
        pathname,
        method: 'GET',
        key: ['admin-platform-costs-overview', period.startDate, period.endDate],
    });

    const payload = data?.data ?? null;

    return {
        overview: payload
            ? {
                  periodLabel: payload.periodLabel,
                  currency: payload.currency,
                  monthToDateCents: payload.monthToDateCents,
                  previousMonthCents: payload.previousMonthCents,
                  projectedMonthEndCents: payload.projectedMonthEndCents,
                  providers: payload.providers,
                  dailySpend: payload.dailySpend,
                  attributionCoverage: payload.attributionCoverage,
              }
            : null,
        coverage: payload?.coverage ?? null,
        attributionCoverage: payload?.attributionCoverage ?? null,
        isLoadingOverview: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useGetPlatformCostsOverview;
